var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-treeview',{attrs:{"open-all":"","open-on-click":"","dense":"","item-disabled":"locked","items":_vm.items,"activatable":""},scopedSlots:_vm._u([{key:"label",fn:function(ref){
var item = ref.item;
return [_c('div',{on:{"click":function($event){return _vm.clickOnTreeMenuItem(item)}}},[_vm._v(_vm._s(item.name))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }